import React from 'react';
import SoundButton from './SoundButton';
import SoundDivider from './SoundDivider'
import { View, Text, FlatList, Image, TouchableOpacity } from 'react-native';
import heroes from './assets/heroes.json';
import tokens from './assets/tokens.json';
import {complicatedAltSound, AVHeroPowers, transferStudentTokens} from './HelperFunctions';

const TokensFlatList = (props) => {

  const heroTokens = {
    "WARRIOR": ["HERO_01bp"],
    "SHAMAN": ["HERO_02bp","NEW1_009","CS2_050","CS2_051","CS2_052","AT_132_SHAMANe"],
    "ROGUE": ["HERO_03bp","CS2_082"],
    "PALADIN": ["HERO_04bp","CS2_101t"],
    "HUNTER": ["HERO_05bp"],
    "DRUID": ["HERO_06bp"],
    "WARLOCK": ["HERO_07bp"],
    "MAGE": ["HERO_08bp"],
    "PRIEST": ["HERO_09bp"],
    "DEMONHUNTER": ["HERO_10bp"],
    "DEATHKNIGHT": ["HERO_11bp", "HERO_11bpt"]
  }

  const cardID = complicatedAltSound(props.cardID)
  const isHero =  heroes.map(a => a.id).includes(props.cardID)
  const hasTokens = (tokens.map(a => a.parentID).includes(cardID) || isHero || cardID == 'SCH_199')
  let tokenList = (isHero ? heroTokens[props.cardClass] : tokens.filter(x => x.parentID == cardID).map(a => a.tokenID))

  /* Transfer student special case */
  if (cardID == 'SCH_199') {
    tokenList = transferStudentTokens
  }

  return (
    <>
    {hasTokens
      ?
      <>
        <View style={{flexDirection: 'row', alignSelf: 'flex-start', width: "100%", paddingBottom: 8}}>
          <Text style={{alignSelf: 'flex-start', paddingRight: 8, fontWeight: 'bold', width: 80}}>Related</Text>
            <FlatList
              horizontal='true'
              data={(tokenList)}
              renderItem={({item}) => (
                  <TouchableOpacity onPress={() => {props.openNewCard(item)}}>
                    <TokenImage cardID={item} battlegrounds={props.battlegrounds}/>
                  </TouchableOpacity>
              ) }
            />
      </View>
      <SoundDivider/>
      </>
      : <></>
    }
    </>
  )
}

const TokenImage = (props) => {
  const isHero =  heroes.map(a => a.id).includes(props.cardID)
  const imgSrc = getImage(props.cardID)

    function getImage(cardID) {
      if (isHero || ['EX1_323h'].includes(cardID) || AVHeroPowers.includes(cardID)) {
        return 'https://hearthstonesounds.s3.amazonaws.com/' + cardID + '.png'
      } else if (props.battlegrounds) {
        return 'https://art.hearthstonejson.com/v1/bgs/latest/enUS/256x/' + cardID + '.png'
      } else {
        return 'https://art.hearthstonejson.com/v1/render/latest/enUS/256x/' + cardID + '.png'
      }
    }

  return (
    <View style={{padding: 10}}>
      <Image source={{uri: imgSrc}} style={{width: 128, height: 194, resizeMode:'stretch'}}/> 
    </View>
  )
}

export default TokensFlatList
